import store from "../../index";
import calendarAPIService from "./calendarAPIService";
import calendarSocket from "../../../socket/calendarSocket";

import { SLOT_INTERVAL_MS, COVERED_BY_SLOT_COUNT } from "../../../constants_calendar";
import ViewController from "./viewController";
import { CalendarStore, ELYXCentralStore } from "../../../ELYX/ELYXStore";

import { SharedSessionUtilities } from "../../../../../shared";
import CalendarUtilities from "../../../ELYX/Calendar/CalendarUtilities";
import ELYXConstants from "../../../ELYX/ELYXConstants";

function getPartnerSessionData(partner) {
  if (!partner) return null;
  return {
    rematch: partner.session.rematch,
    worktype: partner.session.worktype,
  };
}

/**
 * Requests current user's private matching data from backend
 * @param {String} userID
 */
async function setCurrentUserData(userID) {
  let currentUserData = store.state.calendar.currentUserData;
  // console.log("@setCurrentUserData: current ", currentUserData);
  if (currentUserData === null) {
    // console.log("@setCurrentUSerData request sent!");
    currentUserData = await calendarAPIService.getCurrentUserData(userID);
    console.log("@setCurrentUserData request currentUserData: ", currentUserData);
    if (currentUserData) {
      await store.dispatch("calendar/setCurrentUserData", currentUserData);
    }
  }
  return currentUserData;
}

/**
 * With this there are 4 options:
 * 1. The cancelled user is the current user. Then remove match from datetime
 * 2. The cancelled user was matched to the current user. Then set partner data to null in upcoming store
 * 3. The cancelled user was in the match pool. Then remove them from the match pool (always checked)
 * 4. Else ignore
 * @param {
 *  dateTimeMS: cancellation dateTime
 *  removedID: the removed user's ID
 *  currentUserID: this user's ID
 * } removedData
 */
async function _handleRemovedUser(removedData) {
  const removedID = removedData.ID;
  const dateTimeMS = Number(removedData.dateTimeMS);
  const currentUserID = removedData.currentUserID;
  console.log("@handleRemovedUser: ", removedID, dateTimeMS, currentUserID);
  /* 1. The cancelled user is the current user. */
  if (removedID === currentUserID) store.dispatch("upcomingMatches/deleteUpcomingMatch", dateTimeMS);
  else {
    console.log("@handleRemovedUser else");
    const match = store.getters["upcomingMatches/getMatchForDateTime"](dateTimeMS);
    console.log("@handleRemovedUser match: ", match);
    if (match && match.partnerID === removedID) {
      /* 2. The cancelled user was matched to the current user. */
      console.log("@handleRemovedUser removing upcoming match");
      store.dispatch("upcomingMatches/removeUpcomingMatchPartner", dateTimeMS);
    }
  }
  /* 3. The cancelled user was in the match pool. (Always must be checked) */
  store.dispatch("matchPool/removeOneFromSlot", removedData);
}

const StoreMatchController = {
  /**
   * TEMPORARY FIX
   */

  async refreshCalendarData() {
    const userID = store.state.auth.user._id;
    const viewStartMS = store.state.calendar.viewStartMS;
    const viewEndMS = store.state.calendar.viewEndMS;
    await ViewController.refreshCurrentView(userID, viewStartMS, viewEndMS);
  },

  /* ================ DATABASE LOADING ================ */

  /**
   * Loads data from database and sets it to Vuex
   * @param {String} userID current user's ID
   * @param {Number/String} startDateMS -- start date (rounded down to nearest slot, inclusive)
   * @param {Number/String} endDateMS -- end date (rounded up to nearest slot, exclusive)
   */
  async loadDataFromDatabase(userID, startDateMS, endDateMS) {
    let matchData;
    startDateMS = Math.floor(startDateMS / SLOT_INTERVAL_MS) * SLOT_INTERVAL_MS;
    endDateMS = Math.ceil(endDateMS / SLOT_INTERVAL_MS) * SLOT_INTERVAL_MS;
    try {
      const requestArray = [];
      requestArray.push(setCurrentUserData(userID));
      requestArray.push(calendarAPIService.getSessionsInRange(userID, startDateMS, endDateMS));
      const result = await Promise.all(requestArray);
      console.log("@loadFromDatabase: ", result);

      matchData = result[1];
    } catch (error) {
      console.error("@loadDataFromDatabase error: ", error);
      return;
    }
    store.dispatch("pastMatches/addFromDB", matchData.pastSessions);
    store.dispatch("upcomingMatches/addFromDB", {
      dataStart: startDateMS,
      dataEnd: endDateMS,
      upcomingSessions: matchData.upcomingSessions,
    });
    store.dispatch("matchPool/addFromDB", {
      dataStart: startDateMS,
      dataEnd: endDateMS,
      matchablePeople: matchData.matchablePeople,
    });
  },

  /* ================ REAL TIME UPDATES FROM SOCKET ================ */
  /**
   * Replace the current match at dateTimeMS with the new partnerData. There is no need to check availabilities since
   * the user must have already been in the calendar, thus the availabilities must have already been calculated.
   * @param {
   *  dateTimeMS -- in ms
   *  partner: {
   *    metadata: {Object}
   *    preferences: {Object}
   *    session: {Object}
   *  }
   * } matchData -- matched User's data
   */
  async handleMatchCreated(matchData) {
    console.log("@handleMatchCreated, matchData: ", matchData);
    const partnerID = matchData.partner && matchData.partner.metadata ? matchData.partner.metadata.ID : null;
    /* add to calendarUsers -- check for existence is done there */
    store.dispatch("calendarUsers/setUser", matchData.partner);

    console.log("@handlewNewMatch setting new match at ", new Date(matchData.dateTimeMS), "to ", matchData.partner);
    store.dispatch("upcomingMatches/setUpcomingMatchPartner", {
      dateTimeMS: Number(matchData.dateTimeMS),
      SID: matchData.SID,
      partnerID,
      partnerSessionData: getPartnerSessionData(matchData.partner),
    });
    const dateTimeMSArray = [];
    for (let i = -COVERED_BY_SLOT_COUNT; i <= COVERED_BY_SLOT_COUNT; i++) {
      dateTimeMSArray.push(matchData.dateTimeMS + i * SLOT_INTERVAL_MS);
    }
    store.dispatch("calendar/setSlotArrayFieldStatus", {
      dateTimeMSArray,
      field: "isAvailableForBooking",
      value: false,
    });
  },

  /**
   * If this was the partner, don't do anything, otherwise remove from pool
   * @param {
   *  dateTimeMS: cancellation dateTime
   *  removedID: the removed user's ID
   *  currentUserID: this user's ID
   * } joinedData
   */
  async handleJoinedSession(joinedData) {
    const { ID, dateTimeMS, currentUserID } = joinedData;
    console.log("@handleJoinedSession args: ", joinedData);
    if (ID !== currentUserID) {
      const match = store.getters["upcomingMatches/getMatchForDateTime"](dateTimeMS);
      console.log("match exists: ", match);

      if (!match || match.partnerID !== ID) {
        /* if match exists and joined user is not partner, remove from pool */
        await _handleRemovedUser(joinedData);
      }
      /* otherwise do nothing */
    }
  },

  async handleRemovedUser(removedData) {
    return _handleRemovedUser(removedData);
  },

  /**
   * Puts the new user to the match pool, if preferences fit.
   * @param {
   *  dateTimeMS: {String}
   *  user: {
   *    metadata: {Object}
   *    preferences: {Object}
   *    session: {Object} // worktype, rematch, session length etc
   *  }
   * } newUserData the user who appeared in the calendar
   */
  async handleNewUser(newUserData, currentUserID) {
    console.log("@handleNewUser: ", newUserData);
    console.log("@handleNewUser: ", newUserData.user.metadata.ID, currentUserID);
    if (
      newUserData.user &&
      newUserData.user.metadata &&
      newUserData.user.metadata.ID != currentUserID
      // && store.state.matchPool.dataStartMS <= newUserData.dateTimeMS
      // && store.state.matchPool.dataEndMS >= newUserData.dateTimeMS
    ) {
      /* add the user to calendarUsers */
      const score = await store.dispatch("calendarUsers/setUser", newUserData.user);
      newUserData.score = score;
      store.dispatch("matchPool/addOneMatchPoolUser", newUserData);
    }
  },

  /* ================ USER ACTIONS ================ */

  async bookSession(dateTimeMS) {
    if (store.getters["selections/currentlyBooking"]) {
      return;
    }

    try {
      store.dispatch("selections/setCurrentlyBooking", true);
      const { user, partner } = getOneSlotBookingData(dateTimeMS);
      const hasBookedSession = store.state.onboarding.hasBookedSession;
      const bookingResult = await calendarSocket.bookOneSlot(dateTimeMS, user, partner, hasBookedSession);
      store.dispatch("selections/setCurrentlyBooking", false);

      if (!bookingResult || !bookingResult.success) {
        throw new Error("Session booking failed.");
      }

      if (SharedSessionUtilities.isUserAllowedToBook(bookingResult.bookingStatusCode)) {
        StoreMatchController.handleSuccessfulBooking(bookingResult, dateTimeMS, user, partner);
      } else {
        StoreMatchController.handleUnsuccessfulBooking(bookingResult.userBookingData, bookingResult.bookingStatusCode);
      }
    } catch {
      StoreMatchController.handleFailedBookingRequest();
    }
  },

  handleSuccessfulBooking(bookingResult, dateTimeMS, user, partner) {
    window.mixpanel.track("Book One Session");
    if (bookingResult.updatedHasBookedSession) {
      store.dispatch("onboarding/setHasBookedSession", true);
    }
    store.dispatch("upcomingMatches/setUpcomingMatch", {
      dateTimeMS,
      SID: bookingResult.createdMatches[0]._id,
      partnerID: partner && partner.metadata ? partner.metadata.ID : null,
      partnerSessionData: partner ? partner.session : null,
      currentSessionData: user.session,
    });

    /* updating booking availability */
    let dateTimeMSArray = [];
    for (let i = -COVERED_BY_SLOT_COUNT; i <= COVERED_BY_SLOT_COUNT; i++) {
      dateTimeMSArray.push(dateTimeMS + i * SLOT_INTERVAL_MS);
    }
    store.dispatch("calendar/setSlotArrayFieldStatus", {
      dateTimeMSArray,
      field: "isAvailableForBooking",
      value: false,
    });
    store.dispatch("selections/cancelSlot", dateTimeMS);
    CalendarStore.methods.addToBookedCount(1);
  },

  handleUnsuccessfulBooking(userBookingData, bookingStatusCode) {
    CalendarStore.methods.updateBookingRestrictionData(userBookingData);
    CalendarUtilities.displayBookingRestrictionModal(bookingStatusCode);
  },

  handleFailedBookingRequest() {
    ELYXCentralStore.methods.setModal(ELYXConstants.modals.CalendarRequestFailedModal);
  },

  async bookManySessions(dateTimeMSArray) {
    if (store.getters["selections/currentlyBooking"]) {
      return;
    }

    try {
      /** Store initial number of sessions attempting to book, as we later modify
       * the dateTimeMSArray, which leads to a different, incorrect count. */
      const attemptingToBookCount = dateTimeMSArray.length;

      store.dispatch("selections/setCurrentlyBooking", true);
      let bookingData = getManySlotBookingData(dateTimeMSArray);
      const hasBookedSession = store.state.onboarding.hasBookedSession;
      bookingData.hasBookedSession = hasBookedSession;
      const bookingResult = await calendarSocket.bookManySlots(bookingData);
      store.dispatch("selections/setCurrentlyBooking", false);

      if (!bookingResult || !bookingResult.success) {
        throw new Error("Booking one or more sessions failed.");
      }

      if (SharedSessionUtilities.isUserAllowedToBook(bookingResult.bookingStatusCode)) {
        window.mixpanel.track("Book Many Sessions");
        if (bookingResult.updatedHasBookedSession) {
          store.dispatch("onboarding/setHasBookedSession", true);
        }
        let dateTimeMSArray = [];
        for (let i = 0; i < bookingData.sessions.length; i++) {
          const session = bookingData.sessions[i];
          const dateTimeMS = Number(session.d);
          if (!bookingResult[dateTimeMS]) continue;
          store.dispatch("upcomingMatches/setUpcomingMatch", {
            dateTimeMS,
            SID: bookingResult[dateTimeMS],
            partnerID: session.partner && session.partner.metadata && session.partner.metadata.ID ? session.partner.metadata.ID : null,
            partnerSessionData: session.partner ? session.partner.session : null,
            currentSessionData: session.userSession,
          });
          for (let j = -COVERED_BY_SLOT_COUNT; j <= COVERED_BY_SLOT_COUNT; j++) {
            dateTimeMSArray.push(dateTimeMS + j * SLOT_INTERVAL_MS);
          }
          store.dispatch("selections/cancelSlot", dateTimeMS);
        }
        store.dispatch("calendar/setSlotArrayFieldStatus", {
          dateTimeMSArray,
          field: "isAvailableForBooking",
          value: false,
        });

        /* Synchronize bookedCount */
        CalendarStore.methods.addToBookedCount(attemptingToBookCount);
      } else {
        StoreMatchController.handleUnsuccessfulBooking(bookingResult.userBookingData, bookingResult.bookingStatusCode);
      }
    } catch {
      StoreMatchController.handleFailedBookingRequest();
    }
  },

  /**
   * Called in CancelSession after canceling a booking was successful
   * and the person was removed from match pool or match was removed (if was not in the pool).
   * @param {Number} dateTimeMS -- datetime when the match was
   * @param {String} currentUserID the ID of the user who cancelled the session
   */
  async cancelSession(dateTimeMS, currentUserID) {
    const { partnerID, partnerSessionData } = store.state.upcomingMatches.upcomingMatches[dateTimeMS];
    const addToPoolPromise = addToMatchPoolAfterCancel(dateTimeMS, partnerID, partnerSessionData);
    const cancelPromise = calendarSocket.cancelOneSlot(dateTimeMS, currentUserID);
    try {
      const [_, cancelResult] = await Promise.all([addToPoolPromise, cancelPromise]); // eslint-disable-line no-unused-vars
      if (!cancelResult) {
        throw new Error("Failed to cancel session.");
      }
      /* remove match, then update booking availability */
      /* selectability changing is handled in the action */
      store.dispatch("upcomingMatches/deleteUpcomingMatch", dateTimeMS);
      store.dispatch("calendar/setOneSlotFieldStatus", {
        dateTimeMS,
        field: "isCanceling",
        value: false,
      });
      store.dispatch("selections/setCurrentlyBooking", false);
      CalendarStore.methods.subtractFromBookedCount(1);
      window.mixpanel.track("Cancel One Session");
    } catch (error) {
      console.error("@cancelSession", error);
    }
  },
};

/**
 * Compiles booking data if booked just one slot.
 */
function getOneSlotBookingData(dateTimeMS) {
  const metadata = store.getters["calendar/getCurrentUserMetadata"];
  const publicPreferences = store.getters["calendar/getCurrentUserPublicPreferences"];
  const session = store.getters["selections/getSelectionData"](dateTimeMS);
  return {
    user: {
      metadata,
      preferences: publicPreferences,
      session: session.currentUserSession,
    },
    partner: session.partner,
  };
}

/**
 * Compiles booking data if booked many slots.
 * @return {
 * metadata: {Object} current user metadata
 * preferences: {Object} current user preferences
 * sessionArray: [
 *  {
 *    d: {Number} (dateTimeMS)
 *    userSession: {Object},
 *    partner: { metadata, preferences, session }
 *  },
 *  ...
 * ]}
 */
function getManySlotBookingData(dateTimeMSArray) {
  /* current user metadata and public preferences (constants) */
  const metadata = store.getters["calendar/getCurrentUserMetadata"];
  const publicPreferences = store.getters["calendar/getCurrentUserPublicPreferences"];
  const sessionArray = [];
  for (let i = 0; i < dateTimeMSArray.length; i++) {
    const dateTimeMS = dateTimeMSArray[i];
    const session = store.getters["selections/getSelectionData"](dateTimeMS);
    sessionArray.push({
      d: dateTimeMS,
      userSession: session.currentUserSession,
      partner: session.partner,
    });
  }
  return {
    metadata,
    preferences: publicPreferences,
    sessions: sessionArray,
  };
}

async function addToMatchPoolAfterCancel(dateTimeMS, partnerID, partnerSessionData) {
  /* if partner exists and is rematchable, add the partner to match pool */
  if (partnerID && partnerSessionData) {
    let partnerData = store.state.calendarUsers.users[partnerID];
    let score = 0;
    if (partnerData.score || partnerData.score === 0) {
      score = partnerData.score;
    }
    console.log("@addToMatchPoolAfterCancel partnerData: ", partnerData);
    console.log("@addToMatchPoolAfterCancel partnerSessionData: ", partnerSessionData);
    if (!partnerData || !partnerData.preferences) {
      /* user does not exist in calendarUsers, need to request*/
      console.log("Requesting from backend");
      partnerData = await calendarAPIService.getCalendarUserData(partnerID);
      console.log("PartnerData:", partnerData);
      score = await store.dispatch("calendarUsers/setUser", partnerData);
    }

    await store.dispatch("matchPool/addOneMatchPoolUser", {
      dateTimeMS,
      user: {
        metadata: partnerData ? partnerData.metadata : null,
        session: partnerSessionData,
      },
      score,
    });
  }
}

export default StoreMatchController;
